module.exports = __webpack_public_path__ + "media/payment_icons/visa-c8aa1c59.svg";